<template>
  <div class="main-content">
    <!-- 头部区域：左侧标题，右侧新增按钮 -->
    <div
      class="header-wrapper marginBottom20 flex justify-between align-center"
    >
      <div class="page-title">课程包分类管理</div>
      <el-button
        type="primary"
        size="medium"
        icon="el-icon-plus"
        @click="handleCreate"
      >
        新增分类
      </el-button>
    </div>

    <!-- 数据表格 -->
    <div class="table-container">
      <el-table
        v-loading="showLoading"
        :data="tableData"
        border
        style="width: 100%"
      >
        <!-- 分类名称 -->
        <el-table-column
          prop="name"
          label="分类名称"
          header-align="center"
          align="center"
        >
          <template slot-scope="{ row }">
            <span class="classify-name">{{ row.name }}</span>
          </template>
        </el-table-column>

        <!-- 课程数量 -->
        <el-table-column prop="packageCount" label="课程数量" align="center">
          <template slot-scope="{ row }">
            <span>{{
              row.packageCount !== null && row.packageCount !== undefined
                ? row.packageCount
                : 0
            }}</span>
          </template>
        </el-table-column>

        <!-- 排序 -->
        <el-table-column prop="sort" label="排序" align="center">
        </el-table-column>

        <!-- 启用状态 -->
        <el-table-column label="启用状态" align="center">
          <template slot-scope="{ row }">
            <el-switch
              v-model="row.state"
              :active-value="1"
              :inactive-value="2"
              @change="handleStateChange(row)"
            ></el-switch>
          </template>
        </el-table-column>

        <!-- 创建时间 -->
        <el-table-column prop="createTime" label="创建时间" align="center">
          <template slot-scope="{ row }">
            <span>{{ formatTime(row.createTime) }}</span>
          </template>
        </el-table-column>

        <!-- 操作 -->
        <el-table-column label="操作" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              size="small"
              class="action-btn btn-edit"
              @click="handleEdit(row)"
            >
              编辑
            </el-button>
            <el-button
              type="text"
              size="small"
              class="action-btn btn-delete"
              @click="handleDelete(row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页区域 -->
    <div class="pagination-container marginTop20 flex justify-end">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.current"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="page.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total"
      >
      </el-pagination>
    </div>

    <!-- 新增/修改弹窗 -->
    <el-dialog
      v-if="dialogVisible"
      :title="form.id ? '编辑课程包分类' : '新增课程包分类'"
      :visible.sync="dialogVisible"
      width="480px"
      :before-close="handleClose"
      :close-on-click-modal="false"
      class="classify-dialog"
    >
      <el-form
        ref="formRef"
        :model="form"
        :rules="formRules"
        label-width="90px"
        size="medium"
        style="padding: 0 10px"
      >
        <!-- 分类名称 -->
        <el-form-item label="分类名称" prop="name">
          <el-input
            v-model="form.name"
            maxlength="20"
            placeholder="请输入分类名称"
            clearable
            show-word-limit
          ></el-input>
        </el-form-item>

        <!-- 排序 -->
        <el-form-item label="排序" prop="sort">
          <el-input-number
            v-model="form.sort"
            :min="1"
            :max="9999"
            controls-position="right"
            placeholder="请输入排序值"
            style="width: 100%"
          ></el-input-number>
        </el-form-item>

        <!-- 启用状态 -->
        <el-form-item label="启用状态" prop="state">
          <el-switch
            v-model="form.state"
            :active-value="1"
            :inactive-value="2"
          ></el-switch>
        </el-form-item>
      </el-form>

      <!-- 弹窗底部操作按钮 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="medium">取 消</el-button>
        <el-button
          type="primary"
          @click="submit"
          :loading="showLoadingForm"
          size="medium"
          class="btn-submit"
        >
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  coursePackageClassifyList,
  coursePackageClassifyAdd,
  coursePackageClassifyUpdate,
  coursePackageClassifyDelete,
  coursePackageClassifyStateUpdate,
} from "@/api/course/packageClassify";

export default {
  name: "CoursePackageClassify",
  data() {
    return {
      tableData: [],
      showLoading: false,
      showLoadingForm: false, // 提交防抖
      dialogVisible: false,
      page: {
        current: 1,
        size: 10,
        total: 0,
      },
      form: {
        id: "",
        name: "",
        sort: 1,
        state: 1,
      },
      formRules: {
        name: [
          { required: true, message: "请输入分类名称", trigger: "blur" },
          { max: 20, message: "分类名称不能超过 20 个字符", trigger: "blur" },
        ],
        sort: [{ required: true, message: "请输入排序值", trigger: "blur" }],
        state: [
          { required: true, message: "请选择启用状态", trigger: "change" },
        ],
      },
    };
  },
  created() {
    this.initData();
  },
  methods: {
    // 初始化数据
    initData() {
      this.onLoad();
    },

    // 加载列表数据
    onLoad() {
      this.showLoading = true;
      const params = {
        page: this.page.current,
        size: this.page.size,
      };
      coursePackageClassifyList(params)
        .then((res) => {
          this.showLoading = false;
          if (res.code === 200 && res.data) {
            this.tableData = res.data.records || [];
            this.page.total = Number(res.data.total) || 0;
          }
        })
        .catch(() => {
          this.showLoading = false;
        });
    },

    // 格式化时间
    formatTime(time) {
      if (!time) return "—";
      try {
        const date = new Date(time);
        if (isNaN(date.getTime())) return time;
        const pad = (num) => String(num).padStart(2, "0");
        const y = date.getFullYear();
        const m = pad(date.getMonth() + 1);
        const d = pad(date.getDate());
        const h = pad(date.getHours());
        const min = pad(date.getMinutes());
        return `${y}-${m}-${d} ${h}:${min}`;
      } catch (e) {
        return time;
      }
    },

    // 每页条数切换
    handleSizeChange(val) {
      this.page.size = val;
      this.page.current = 1;
      this.onLoad();
    },

    // 页码切换
    handleCurrentChange(val) {
      this.page.current = val;
      this.onLoad();
    },

    // 快捷切换启用/禁用状态
    handleStateChange(row) {
      const originalState = row.state === 1 ? 2 : 1;
      const stateText = row.state === 1 ? "启用" : "禁用";

      coursePackageClassifyStateUpdate({
        id: row.id,
        state: row.state,
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success(`已成功将分类【${row.name}】${stateText}`);
            this.onLoad();
          } else {
            row.state = originalState;
          }
        })
        .catch(() => {
          row.state = originalState;
        });
    },

    // 新增按钮点击
    handleCreate() {
      this.form = {
        id: "",
        name: "",
        sort: 1,
        state: 1,
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },

    // 编辑按钮点击
    handleEdit(row) {
      this.form = {
        id: row.id,
        name: row.name,
        sort: row.sort || 1,
        state: row.state,
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },

    // 删除按钮点击
    handleDelete(row) {
      this.$confirm(`此操作将永久删除分类【${row.name}】, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
      })
        .then(() => {
          coursePackageClassifyDelete(row.id).then((res) => {
            if (res.code === 200) {
              this.$message.success("删除成功!");
              this.onLoad();
            }
          });
        })
        .catch(() => {});
    },

    // 关闭弹窗并重置表单
    handleClose() {
      this.dialogVisible = false;
      this.form = {
        id: "",
        name: "",
        sort: 1,
        state: 1,
      };
      if (this.$refs.formRef) {
        this.$refs.formRef.clearValidate();
      }
    },

    // 提交新增/修改表单
    submit() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          if (this.showLoadingForm) return;
          this.showLoadingForm = true;

          const submitData = {
            ...this.form,
            name: this.form.name.trim(),
          };

          const requestApi = submitData.id
            ? coursePackageClassifyUpdate
            : coursePackageClassifyAdd;

          requestApi(submitData)
            .then((res) => {
              this.showLoadingForm = false;
              if (res.code === 200) {
                this.$message.success("操作成功");
                this.dialogVisible = false;
                this.onLoad();
              }
            })
            .catch(() => {
              this.showLoadingForm = false;
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.main-content {
  padding: 20px;
  background-color: #ffffff;
  min-height: calc(100vh - 100px);
}

.header-wrapper {
  padding: 10px 0;
  border-bottom: 1px solid #ebeef5;
}

.page-title {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
}

.table-container {
  margin-top: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  overflow: hidden;
}

.classify-name {
  font-weight: 500;
  color: #333333;
}

/* 操作列按钮样式 */
.action-btn {
  font-weight: 500;
  font-size: 14px;
  margin: 0 10px;
  padding: 0;
  border: none;
}

.btn-delete {
  color: #ff001f !important;
}
.btn-delete:hover {
  color: #cc0018 !important;
  text-decoration: underline;
}

.dialog-footer {
  text-align: right;
}

/* 间距及布局工具类 */
.marginBottom20 {
  margin-bottom: 20px;
}
.marginTop20 {
  margin-top: 20px;
}
.flex {
  display: flex;
}
.justify-between {
  justify-content: space-between;
}
.justify-end {
  justify-content: flex-end;
}
.align-center {
  align-items: center;
}
</style>